import axios from '../index';

export const requestRedcapDictionary = () => axios.get(`/redcap/getDictionary`);

export const requestCheckDictionary = () => axios.get(`/redcap/checkDictionary`);

export const requestUpdateDictionary = updatedDictionary => {
  axios.put(`/redcap/updateDictionary`, { updatedDictionary });
};
